import { Carrier } from "@/pages/catalogs/models/Carrier";
import { MenuOptionType } from "@dexteel/mesf-core";
import { DeleteSweep } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/FileCopy";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

type Props = {
	setSelectedRowData: (carrier: Carrier) => void;
	setShowModal: (
		modal: "create" | "update" | "delete" | "deleteMultiple" | "",
	) => void;
};
export const useCarrierOptionsFunctions = ({
	setSelectedRowData,
	setShowModal,
}: Props) => {
	const getMenuOptions = (data: Carrier | any) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Carrier",
				key: "new_carrier",
				onClick: () => {
					setShowModal("create");
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Edit Carrier",
					key: "edit_carrier",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("update");
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Carrier",
					key: "delete_carrier",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("delete");
					},
					icon: <DeleteIcon />,
				},
				...(data.selectedRows.length > 1
					? [
							{
								name: `Delete selected (${data.selectedRows.length})`,
								key: "delete_selected_carriers",
								onClick: () => {
									setShowModal("deleteMultiple");
								},
								icon: <DeleteSweep />,
							},
						]
					: []),
				{
					name: "Duplicate Carrier",
					key: "duplicate_carrier",
					onClick: () => {
						setSelectedRowData({
							PartId: data.PartId,
							PartName: `${data.PartName} (Copy)`,
							RFIDTag: null,
							LocationId: data.LocationId,
							LocationName: data.LocationName,
							CarrierStatusCode: data.AssemblyStatusCode,
							Comments: data.Comments,
							IsActive: true,
							IsDuplicate: true,
						});
						setShowModal("create");
					},
					icon: <ContentCopyIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
